import { memo } from 'react';
import { validateFooterChildComponentUpdate } from './ModalConfirmationFooter.utils';
import { ConfirmationPrompt, ModalConfirmationFooterPromptLabelProps } from './types';
import { LabelText, HelpText } from './ModalConfirmationFooter.styled';

export const PromptLabel: React.FC<ModalConfirmationFooterPromptLabelProps> = ({
  confirmHelpText,
  confirmLabel,
  discardHelpText,
  discardLabel,
  promptType,
}) => {
  return promptType === ConfirmationPrompt.CONFIRM ? (
    <span>
      <LabelText>{confirmLabel}</LabelText>
      <HelpText>{confirmHelpText}</HelpText>
    </span>
  ) : (
    <span>
      <LabelText>{discardLabel}</LabelText>
      <HelpText>{discardHelpText}</HelpText>
    </span>
  );
};

/**
 * this memoization is necessary due to the animation that runs before the components are unmounted.
 * Without this custom check, we may show the wrong state of the component while the dismount animation runs.
 */
export const ModalConfirmationFooterPromptLabel = memo(
  PromptLabel,
  validateFooterChildComponentUpdate,
);
